export default __webpack_public_path__ + "static/media/deep-snow.79208d63.png";